import { Divider, Input, Stack, Text, Textarea } from '@mantine/core';
import React, { useCallback } from 'react';

import { PortalConfigType, useFeatureFlags } from '@portals/api/partners';
// import { useConfirmNavigation } from '@portals/framework';
import { isPartnerFeatureOn } from '@portals/framework';

import { StoreBannerSelector } from './StoreBannerSelector';
import { useBrandingContext } from '../../branding.context';
import { DesignColorInput } from '../customer-portal/tool-panel/tabs/design/fields/ColorField';
import { DesignImageInput } from '../customer-portal/tool-panel/tabs/design/fields/ImageField';

export function StoreForm({ disabled = false }: { disabled?: boolean }) {
  const featureFlags = useFeatureFlags();
  const { updatePortalConfig, defaultValues, portalConfig } =
    useBrandingContext();

  const onChange = useCallback(
    (
      key: keyof PortalConfigType['design']['store'],
      value: boolean | string
    ) => {
      updatePortalConfig((curr) => ({
        ...curr,
        design: {
          ...(portalConfig.design || {}),
          store: {
            ...(portalConfig.design?.store || {}),
            [key]: value,
          },
        },
      }));
    },
    [updatePortalConfig, portalConfig.design]
  );

  // useConfirmNavigation({
  //   isActive: !isPristine,
  //   confirmationModal: {
  //     title: 'Leave page without saving?',
  //     description:
  //       'You are about to leave the white-label progress and discard all your work. Are you sure?',
  //     confirmationLabel: 'Discard and Leave',
  //     cancelLabel: 'Keep Editing',
  //   },
  //   onConfirm: revertChanges,
  // });

  return (
    <Stack spacing="md" p="md">
      <Text size="md" color="blue_gray.9">
        Branding
      </Text>

      <Stack>
        <DesignImageInput
          disabled={disabled}
          valuePath={['design', 'store', 'logo']}
          field={{
            title: 'Logo',
            name: 'logo',
            cropConfig: {
              aspectRatio: 1,
              height: 100,
              width: 100,
            },
            previewConfig: {
              width: 100,
              height: 100,
            },
            height: 200,
            inputProps: {
              mb: 15,
            },
          }}
        />

        <Textarea
          disabled={disabled}
          label="Tagline"
          value={
            portalConfig?.design?.store?.tagline ||
            defaultValues?.design.store.tagline
          }
          onChange={(event) => onChange('tagline', event.target.value)}
        />

        <Input.Wrapper>
          <Input.Label mb="xl">Banner</Input.Label>
          <StoreBannerSelector
            onChange={(value) => onChange('with_banner', value)}
            disabled={disabled}
          />
        </Input.Wrapper>
      </Stack>

      {portalConfig?.design?.store?.with_banner ? (
        <DesignImageInput
          valuePath={['design', 'store', 'banner']}
          field={{
            title: 'Banner',
            name: 'banner',
            cropConfig: {
              aspectRatio: 8,
              height: 240,
              width: 1920,
            },
            previewConfig: {
              height: 30,
              width: 240,
            },
            height: 200,
          }}
        />
      ) : null}

      {isPartnerFeatureOn(featureFlags, 'store_branding_colors') ? (
        <Stack spacing="xl">
          <Text size="md" color="blue_gray.9">
            Colors
          </Text>

          <DesignColorInput
            label="Menu buttons color"
            disabled={disabled}
            valuePath={['design', 'store', 'menu_buttons_color']}
          />

          <DesignColorInput
            label="Menu items text color"
            disabled={disabled}
            valuePath={['design', 'store', 'menu_items_text_color']}
          />

          <Divider />

          <DesignColorInput
            disabled={disabled}
            label="Buttons color"
            valuePath={['design', 'store', 'buttons_color']}
          />

          <DesignColorInput
            disabled={disabled}
            label="Buttons text color"
            valuePath={['design', 'store', 'buttons_text_color']}
          />
        </Stack>
      ) : null}
    </Stack>
  );
}
